// Used in mathia.component.ts, view-composite-assignment.component.ts, assignable-expanded-composite.component.ts, assignable-expanded-singular.component.ts,
// assignment-info-dialog.component.ts, tiles.component.ts, lesson-view.component.ts

import { Injectable } from "@angular/core";
import { LevelId, SubjectId } from "@carnegie-learning/common-types";
import { Asset, AssetAssociation, Edition, Level } from "@carnegie-learning/cure-types";

@Injectable()
export class AssetAssociationsHelper {
    constructor() {}

    getLevels(subject: AssetAssociation): Array<Level> {
        if (subject) {
            if (subject.levels) {
                return subject.levels;
            } else if (subject.levelIds) {
                // TODO: get levelNames from ids
            }
        }
        return [];
    }

    getLevelName(levelId: LevelId) {
        // TODO: Get levelName from LevelId
    }

    getAssetLevelNames(
        asset: Asset,
        subject?: AssetAssociation,
        edition?: Edition,
        allEditions?: Edition[]
    ): string {
        let assetLevels: Level[] = [];
        const editionLvIds = edition?.levelIds;

        // getting the full levels from subject based on asset levelids
        if (subject?.levels) {
            assetLevels = subject.levels.filter((level) =>
                asset.levelIds?.some(
                    (id) => id.toLowerCase() === level.levelId.toLowerCase()
                )
            );
        }
        // filter out asset levels based on the selected edition because In the CURE world an asset has multiple editions and levels.
        if (edition?.supplementEditionId && allEditions) {
            const editions: Edition[] = allEditions.filter(
                (e) =>
                    e.editionId === edition.editionId ||
                    e.editionId === edition.supplementEditionId
            );
            assetLevels = assetLevels.filter((l) =>
                editions.find((e) => e.levelIds?.includes(l.levelId))
            );
        } else if (editionLvIds) {
            assetLevels = assetLevels.filter((l) =>
                editionLvIds.includes(l.levelId)
            );
        }

        return assetLevels.map((l) => l.levelName).join(", ");
    }

    // Get Correct Level Display Name
    getLevelDisplayName(
        subjects: AssetAssociation[],
        subjectId: SubjectId,
        levelId: LevelId
    ) {
        let levelDisplayName = "";
        if (subjects && subjects.length > 0) {
            const subject = subjects.find((s) => s.subjectId === subjectId);
            if (subject) {
                const level = subject.levels?.find(
                    (l) => l.levelId === levelId
                );
                if (level) {
                    levelDisplayName = level.levelName;
                }
            }
        }
        return levelDisplayName;
    }

    getSubjectName(subjectId: SubjectId) {
        // TODO: Get Subject Name from subjectId
    }
}
